import { ReactElement } from 'react'

import { useEInvoicingSetup } from '../../hooks/useEInvoicingSetup'
import { EInvoicingDeactivatedBanner } from '../EInvoicingDeactivatedBanner'
import { EInvoicingReactivationPendingBanner } from './elements/EInvoicingReactivationPendingBanner'

export const EInvoicingEnrollmentInformationBanner = (): ReactElement | null => {
  const { kycUnderReview, eInvoiceIntegration, isEInvoicingActivated } = useEInvoicingSetup()

  if (isEInvoicingActivated) {
    return null
  }

  if (eInvoiceIntegration?.status === 'INACTIVE' && kycUnderReview) {
    return <EInvoicingReactivationPendingBanner />
  }

  return <EInvoicingDeactivatedBanner />
}
